import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Kbd.module.css';
/** Représente une touche ou un raccourci (ex. « ⌘K » de la recherche globale, 3.2). */
export function Kbd({ className, ...rest }) {
    const classes = [styles.kbd, className].filter(Boolean).join(' ');
    return _jsx("kbd", { className: classes, ...rest });
}
//# sourceMappingURL=Kbd.js.map